import { Form, Tree } from 'antd';

import FormHeader from '../FormHeader';
import InfoPopover from '../../ui/InfoPopover';

interface DataSelectionProps {
    selectedDataPoint: string;
    setSelectedDataPoint: (value: string) => void;
}

const infoPopoverContent = {
    companyNameLegalName: `Full legal name of the company with the exchange and ticker of reference.`,
    companyNameBrandName: `Display name is a shorter form of a company name that we can use in presentation content (for example ‘Meta Platforms Inc.’ becomes ‘Meta’).`,
};

const DataSelection: React.FC<DataSelectionProps> = ({ selectedDataPoint, setSelectedDataPoint }: DataSelectionProps) => {
    const treeData = [
        {
            title: (
                <span>
                    Company Name (Legal Name){' '}
                    <InfoPopover placement='bottom' trigger='hover' content={infoPopoverContent.companyNameLegalName} />
                </span>
            ),
            key: 'Legal_Name',
            isLeaf: true,
        },
        {
            title: (
                <span>
                    Company Name (Display Name){' '}
                    <InfoPopover placement='bottom' trigger='hover' content={infoPopoverContent.companyNameBrandName} />
                </span>
            ),
            key: 'Display_Name',
            isLeaf: true,
        },
                {
            title: (
                <span>
                    IPO Offering Price
                </span>
            ),
            key: 'IPO_Offering_Price',
            isLeaf: true,
        },
                {
            title: (
                <span>
                    Date First Trading
                </span>
            ),
            key: 'Date_First_Trading',
            isLeaf: true,
        },
    ];
    return (
        <>
            <FormHeader title="Data Selection" />
            <Form.Item name="dataSelection">
                <div>
                    <Tree
                        style={{ width: '100%' }}
                        treeData={treeData}
                        selectedKeys={[selectedDataPoint]}
                        onSelect={(selectedKeys, info) => {
                            if (selectedKeys.length > 0 && info.node.isLeaf) {
                                const selected = selectedKeys[0].toString();
                                setSelectedDataPoint(selected);
                            } else {
                                setSelectedDataPoint(selectedDataPoint);
                            }
                        }}
                        selectable
                        defaultExpandAll
                    />
                </div>
            </Form.Item>
        </>
    );
};

export default DataSelection; 